import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useRef, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { getUserRecommendations } from '@atlaskit/smart-user-picker';
var useRecommendation = function useRecommendation() {
  var intl = useIntl();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filterOptions = _useState2[0],
    setFilterOptions = _useState2[1];
  var _useState3 = useState('empty'),
    _useState4 = _slicedToArray(_useState3, 2),
    status = _useState4[0],
    setStatus = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var initialData = useRef();
  var convertRecommendationsToFilterOptions = function convertRecommendationsToFilterOptions(recommendations) {
    return recommendations.map(function (item) {
      return {
        optionType: 'avatarLabel',
        label: item.name,
        value: item.id,
        avatar: item.avatarUrl
      };
    });
  };
  var fetchFilterOptions = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var userId, cloudId, searchTerm, requestParams, initialResponseData, isRequestLikeInitialSearch, recommendations;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userId = _ref.userId, cloudId = _ref.cloudId, searchTerm = _ref.searchTerm;
            setStatus('loading');
            requestParams = {
              context: {
                contextType: 'contributors',
                principalId: userId || '',
                productAttributes: {
                  isEntitledConfluenceExternalCollaborator: true
                },
                productKey: 'confluence',
                siteId: cloudId
              },
              includeGroups: false,
              includeTeams: false,
              includeUsers: true,
              maxNumberOfResults: 10,
              performSearchQueryOnly: false,
              query: searchTerm
            };
            initialResponseData = initialData.current;
            isRequestLikeInitialSearch = !searchTerm;
            _context.prev = 5;
            if (!(isRequestLikeInitialSearch && initialResponseData)) {
              _context.next = 10;
              break;
            }
            _context.t0 = initialResponseData;
            _context.next = 13;
            break;
          case 10:
            _context.next = 12;
            return getUserRecommendations(requestParams, intl);
          case 12:
            _context.t0 = _context.sent;
          case 13:
            recommendations = _context.t0;
            setFilterOptions(convertRecommendationsToFilterOptions(recommendations));
            setStatus('resolved');
            if (!searchTerm) {
              /**
               * The initial dataset is used in couple of paths, eg: when a user searches and clears the search text.
               * During these times, we dont want to fetch data again and again, hence a mini cache setup to store and provide the initial dataset
               */
              initialData.current = recommendations;
            }
            _context.next = 23;
            break;
          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](5);
            setStatus('rejected');
            setErrors([_context.t1]);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 19]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [intl]);
  var reset = useCallback(function () {
    setStatus('empty');
    setFilterOptions([]);
    setErrors([]);
    initialData.current = undefined;
  }, []);
  return {
    status: status,
    errors: errors,
    filterOptions: filterOptions,
    reset: reset,
    fetchFilterOptions: fetchFilterOptions
  };
};
export default useRecommendation;